import { redirect } from "@tanstack/react-router";
import { decodeJwt } from "jose";

export const COMPANY_TOKEN_STORAGE_KEY = "token";
export const STORE_TOKEN_STORAGE_KEY = "storeToken";

export function validateToken(token: string | null): boolean {
  if (!token) {
    return false;
  }

  try {
    const payload = decodeJwt(token);
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}

type RequireAuthOptions = {
  loginPath: "/login/company" | "/login/store";
  tokenStorageKey: typeof COMPANY_TOKEN_STORAGE_KEY | typeof STORE_TOKEN_STORAGE_KEY;
};

type RedirectIfAuthenticatedOptions = {
  redirectPath: "/company/dashboard" | "/store/dashboard";
  tokenStorageKey: typeof COMPANY_TOKEN_STORAGE_KEY | typeof STORE_TOKEN_STORAGE_KEY;
};

function requireToken({ loginPath, tokenStorageKey }: RequireAuthOptions): string {
  const token = localStorage.getItem(tokenStorageKey);
  if (!validateToken(token)) {
    localStorage.removeItem(tokenStorageKey);
    throw redirect({ to: loginPath });
  }
  return token;
}

function redirectWhenAuthenticated({
  redirectPath,
  tokenStorageKey,
}: RedirectIfAuthenticatedOptions) {
  const token = localStorage.getItem(tokenStorageKey);
  if (validateToken(token)) {
    throw redirect({ to: redirectPath });
  }
}

export function requireAuth(): string {
  return requireToken({
    loginPath: "/login/company",
    tokenStorageKey: COMPANY_TOKEN_STORAGE_KEY,
  });
}

export function requireStoreAuth(): string {
  return requireToken({
    loginPath: "/login/store",
    tokenStorageKey: STORE_TOKEN_STORAGE_KEY,
  });
}

export function redirectIfAuthenticated() {
  redirectWhenAuthenticated({
    redirectPath: "/company/dashboard",
    tokenStorageKey: COMPANY_TOKEN_STORAGE_KEY,
  });
}

export function redirectStoreIfAuthenticated() {
  redirectWhenAuthenticated({
    redirectPath: "/store/dashboard",
    tokenStorageKey: STORE_TOKEN_STORAGE_KEY,
  });
}
